var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"workshop-banner"},[_c('header',[_c('h2',[_vm._v("Workshop")]),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }